export default __webpack_public_path__ + "static/media/icon_status_default.f813df85.svg";